var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsb60X60(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2396 46.5601C28.8424 46.5601 27.7096 47.6928 27.7096 49.0901C27.7096 50.4874 28.8424 51.6201 30.2396 51.6201C31.6369 51.6201 32.7696 50.4874 32.7696 49.0901C32.7696 47.6928 31.6369 46.5601 30.2396 46.5601ZM26.2096 49.0901C26.2096 46.8644 28.0139 45.0601 30.2396 45.0601C32.4654 45.0601 34.2696 46.8644 34.2696 49.0901C34.2696 51.3158 32.4654 53.1201 30.2396 53.1201C28.0139 53.1201 26.2096 51.3158 26.2096 49.0901Z",
    fill: "#A7B1BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1696 22.0001C16.7724 22.0001 15.6396 23.1328 15.6396 24.5301C15.6396 25.9274 16.7724 27.0601 18.1696 27.0601C19.5669 27.0601 20.6996 25.9274 20.6996 24.5301C20.6996 23.1328 19.5669 22.0001 18.1696 22.0001ZM14.1396 24.5301C14.1396 22.3044 15.9439 20.5001 18.1696 20.5001C20.3954 20.5001 22.1996 22.3044 22.1996 24.5301C22.1996 26.7558 20.3954 28.5601 18.1696 28.5601C15.9439 28.5601 14.1396 26.7558 14.1396 24.5301Z",
    fill: "#A7B1BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2396 6.88012C30.6539 6.88012 30.9896 7.2159 30.9896 7.63012V45.8101C30.9896 46.2243 30.6539 46.5601 30.2396 46.5601C29.8254 46.5601 29.4896 46.2243 29.4896 45.8101V7.63012C29.4896 7.2159 29.8254 6.88012 30.2396 6.88012Z",
    fill: "#A7B1BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9405 8.54452C29.9404 8.54466 29.9407 8.54438 29.9405 8.54452L25.8415 13.5834C25.5801 13.9047 25.1077 13.9533 24.7864 13.6919C24.465 13.4305 24.4165 12.9581 24.6778 12.6368L28.7787 7.59572C29.1508 7.14014 29.6737 6.87012 30.2396 6.87012C30.8056 6.87012 31.3285 7.14014 31.7005 7.59572L31.7015 7.59682L35.8015 12.6368C36.0628 12.9581 36.0143 13.4305 35.6929 13.6919C35.3716 13.9533 34.8992 13.9047 34.6378 13.5834L30.5387 8.54452C30.5386 8.54438 30.5389 8.54466 30.5387 8.54452C30.4209 8.40045 30.3086 8.37012 30.2396 8.37012C30.1707 8.37012 30.0584 8.40045 29.9405 8.54452Z",
    fill: "#A7B1BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7596 15.4301C38.7596 15.0159 39.0954 14.6801 39.5096 14.6801H45.1096C45.5239 14.6801 45.8596 15.0159 45.8596 15.4301V21.0301C45.8596 21.4443 45.5239 21.7801 45.1096 21.7801H39.5096C39.0954 21.7801 38.7596 21.4443 38.7596 21.0301V15.4301ZM40.2596 16.1801V20.2801H44.3596V16.1801H40.2596Z",
    fill: "#A7B1BF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1696 27.0601C18.5839 27.0601 18.9196 27.3959 18.9196 27.8101V33.7108L30.6195 40.5834C30.9767 40.7932 31.0961 41.2528 30.8863 41.61C30.6765 41.9671 30.2169 42.0866 29.8598 41.8768L17.7898 34.7868C17.5605 34.6521 17.4196 34.4061 17.4196 34.1401V27.8101C17.4196 27.3959 17.7554 27.0601 18.1696 27.0601Z",
    fill: "#A7B1BF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3097 20.2801C42.7239 20.2801 43.0597 20.6159 43.0597 21.0301V29.5001C43.0597 29.7661 42.9188 30.0121 42.6895 30.1468L30.6195 37.2368C30.2624 37.4466 29.8028 37.3271 29.593 36.97C29.3832 36.6128 29.5026 36.1532 29.8598 35.9434L41.5597 29.0709V21.0301C41.5597 20.6159 41.8954 20.2801 42.3097 20.2801Z",
    fill: "#A7B1BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsb60X60);
export default __webpack_public_path__ + "static/media/USB_60X60.4e8135177bebb2ed9a5e0fef7f48b0e1.svg";
export { ForwardRef as ReactComponent };